import { useAuthContext } from '../context/AuthContext';

/** Convenience hook — re-exports everything from AuthContext */
export function useAuth() {
  return useAuthContext();
}
